import React from 'react';
import moment from 'moment';
import './capital-flight-card.css';
export const CapitalAirIcon = ({ name, assetBaseUrl }) => React.createElement("img", { src: `${assetBaseUrl}air-${name}.svg`, alt: "", "aria-hidden": "true" });
const date = (value, format) => value && moment(value).isValid() ? moment(value).format(format) : '—';
// Only presentation is shared: each search keeps its own prices, API and selection handlers.
export function CapitalFlightCardDirection({ route, label, baggage, labels, assetBaseUrl, showFlightNumbers = true }) {
    const icon = (name) => React.createElement(CapitalAirIcon, { name: name, assetBaseUrl: assetBaseUrl });
    return React.createElement("section", { className: "capital-air-direction", "aria-label": label },
        React.createElement("div", { className: "capital-air-itinerary" },
            React.createElement("div", { className: "capital-air-endpoint" },
                React.createElement("strong", null, date(route.from.time, 'HH:mm')),
                React.createElement("span", null, date(route.from.time, 'DD.MM.YYYY')),
                React.createElement("p", null,
                    route.from.name,
                    React.createElement("br", null),
                    route.from.city)),
            React.createElement("div", { className: "capital-air-line" },
                React.createElement("span", null, route.stopsCount == null ? '—' : route.stopsCount === 0 ? labels.direct : `${labels.transfer}: ${route.stopsCount}`),
                React.createElement("div", null,
                    React.createElement("i", null,
                        icon('route-outer'),
                        icon('route-inner')),
                    React.createElement("i", null,
                        icon('route-outer'),
                        icon('route-inner'))),
                React.createElement("small", null,
                    React.createElement("span", null, route.from.code),
                    React.createElement("span", null, route.to.code))),
            React.createElement("div", { className: "capital-air-endpoint" },
                React.createElement("strong", null, date(route.to.time, 'HH:mm')),
                React.createElement("span", null, date(route.to.time, 'DD.MM.YYYY')),
                React.createElement("p", null,
                    route.to.name,
                    React.createElement("br", null),
                    route.to.city))),
        React.createElement("div", { className: "capital-air-baggage" }, baggage),
        React.createElement("div", { className: "capital-air-airline" },
            icon('direction'),
            React.createElement("span", null, [...(route.airlines || []), ...(showFlightNumbers ? route.flightNumbers || [] : [])].join(' · ') || '—')));
}
export const CapitalFlightCard = React.forwardRef(({ directions, fares, details, expanded, selected, onExpand, onBook, chooseLabel, detailsLabel, assetBaseUrl, detailsId }, ref) => React.createElement("article", { ref: ref, className: `capital-air-card${expanded ? ' is-expanded' : ''}${selected ? ' is-current' : ''}` },
    React.createElement("div", { className: "capital-air-card-main" },
        React.createElement("div", { className: "capital-air-directions" }, directions),
        React.createElement("div", { className: "capital-air-pricing" },
            fares,
            React.createElement("button", { type: "button", className: "capital-air-book", onClick: onBook }, chooseLabel)),
        React.createElement("button", { type: "button", className: "capital-air-expand", "aria-expanded": expanded, "aria-controls": detailsId, "aria-label": detailsLabel, onClick: onExpand },
            React.createElement(CapitalAirIcon, { name: "chevron", assetBaseUrl: assetBaseUrl }))),
    expanded ? React.createElement("div", { id: detailsId, className: "capital-air-details" }, details) : null));
